import gql from 'graphql-tag';
import { Fragments } from '@shared/api/fragments';

export const workspaceSectionChanged = gql`
  subscription WorkspaceSectionChangedSubscription {
    workspaceSectionChanged {
      ...WorkspaceSection
    }
  }
  ${Fragments.channel.workspaceSection}
`;

export const updated = gql`
  subscription ChannelUpdatedSubscription($businessId: Int!) {
    anyChannelUpdated(input: { businessId: $businessId }) {
      channel {
        ...ChannelListItem
      }
    }
  }

  ${Fragments.channel.listItem}
`;
